import axios from 'axios';
import api from '../../api/nodeBackApi';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';


export const loginUser = async (credentials) => {

  try {
    const response = await api.post(`${API_URL}/api/auth/loginUser`, credentials, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    //console.log('Sesión iniciada exitosamente:', response.data);
    return response.data;
  } catch (error) {
    console.error("Error al iniciar sesión:", error);
    throw error;
  }
};



export const forgotPassword = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/api/users/forgotPassword`, userData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    //console.log('Contraseña olvidada exitosamente:', response.data);
    return response.data;
  } catch (error) {
    console.error("Error al olvidar la contraseña:", error);
    throw error;
  }
};

export const handleForgotPasswordWithEmailAndPhone = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/api/users/handleForgotPasswordWithEmailAndPhone`, userData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    console.log('Contraseña olvidada exitosamente:', response.data);
    return response.data;
  } catch (error) {
    console.error("Error al olvidar la contraseña:", error);
    throw error;
  }
};



export const updatePasswordFromLanding = async (id, passwordData) => {
    console.log("ID recibido para actualizar la contraseña desde landing:", id);
    console.log("passwordData recibido para actualizar la contraseña desde landing:", passwordData);

    const newPasswordString = String(passwordData);
    const passwordDataToSend = { newPassword: newPasswordString };

    try {
        const response = await axios.post(`${API_URL}/api/users/updatePasswordFromLanding/${id}`, passwordDataToSend, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        console.log('Contraseña actualizada desde landing exitosamente:', response.data);
        return response.data;
    } catch (error) {
        console.error("Error al actualizar la contraseña desde landing:", error);
        throw error;
    }
}


export const generateUserByURL = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/api/users/generateUserByURl`, userData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    console.log('No se ha podido crear el usuario con url:', response.data);
    return response.data;
  } catch (error) {
    console.error("Error al crear el usuario con url:", error);
    throw error;
  }
};


export const getCustomerIdentifierByCamaraIdentifier = async (camaraIdentifier) => {
  try {
    const response = await axios.get(`${API_URL}/api/camara/getCustomerIdentifierByCamaraIdentifier/${camaraIdentifier}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    console.log('Identificador de cliente obtenido exitosamente:', response.data);
    return response.data;
  } catch (error) {
    console.error("Error al obtener el identificador de cliente:", error);
    throw error;
  }
}


export const handleUpdateOrCreateUser = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/api/users/handleUpdateOrCreateUser`, userData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    console.log('Usuario creado exitosamente:', response.data);
    return response.data;
  } catch (error) {
    console.error("Error al crear el usuario:", error);
    throw error;
  }
}

export const logout = () => {
  localStorage.removeItem('authToken');
  window.location.href = '/';
};
